import { Routes, Route, BrowserRouter } from "react-router-dom";
import { Login } from "./pages/login";
import "./App.css";
import { ROUTES } from "./assets/constant";
import { CheckAuth, CheckSubscription } from "./check-auth";
import Dashboard from "./pages/dashboard";
import { DefaultComponents } from "./defaultComponent";
import { Favourite } from "./pages/favourite";
import { RecallDetails } from "./pages/recall-details";
import { ReportedIssue } from "./pages/reported-issue";
import { ReportedIssueDetails } from "./pages/reported-issue-details";
import PageTitle from "./components/page-title";
import { ManageSubscription } from "./pages/manage-subscription";
import { EditProfile } from "./pages/edit-profile";
import { Register } from "./pages/register";
import { ForgotPassword } from "./pages/forgot-password";
import { ConfirmAccount } from "./pages/confirm-account";
import { ResetPassword } from "./pages/reset-password";
import { SecuritySettingsModal } from "./components/security-settings-modal";
import OTPVerification from "./pages/otp-verification";
import { GlobalSearch } from "./pages/global-search";
import { ChangePassword } from "./pages/change-password";
import { SubscriberPreferences } from "./pages/subscriber-preferences";

function App() {
  return (
    <BrowserRouter basename="/subscriber">
      <Routes>
        {/* Logged in routes */}
        <Route element={<CheckAuth />}>
          <Route element={<DefaultComponents />}>
            <Route
              path={ROUTES.MANAGE_SUBSCRIPTION}
              element={
                <PageTitle title="Manage Subscription">
                  <ManageSubscription />
                </PageTitle>
              }
            />
            <Route
              path={ROUTES.NOTIFICATION_PREFERANCES}
              element={
                <PageTitle title="Notification Preference">
                  <SubscriberPreferences />
                </PageTitle>
              }
            />
            <Route
              path={ROUTES.EDIT_PROFILE}
              element={
                <PageTitle title="Edit Profile">
                  <EditProfile />
                </PageTitle>
              }
            />
            <Route
              path={ROUTES.SECURITY_SETTINGS}
              element={
                <PageTitle title="Security Settings">
                  <SecuritySettingsModal />
                </PageTitle>
              }
            />
            <Route
              path={ROUTES.CHANGE_PASSWORD}
              element={
                <PageTitle title="Change Password">
                  <ChangePassword />
                </PageTitle>
              }
            />
            <Route element={<CheckSubscription />}>
              <Route
                path={ROUTES.DASHBOARD}
                element={
                  <PageTitle title="Dashboard">
                    <Dashboard />
                  </PageTitle>
                }
              />
              <Route
                path={ROUTES.FAVOURITE}
                element={
                  <PageTitle title="Favourite">
                    <Favourite />
                  </PageTitle>
                }
              />
              <Route
                path={`${ROUTES.DASHBOARD}${ROUTES.RECALL_DETAILS}`}
                element={
                  <PageTitle title="Recall Details">
                    <RecallDetails />
                  </PageTitle>
                }
              />
              <Route
                path={ROUTES.REPORTED_ISSUE}
                element={
                  <PageTitle title="Reported Issue">
                    <ReportedIssue />
                  </PageTitle>
                }
              />
              <Route
                path={ROUTES.REPORTED_ISSUE_DETAILS}
                element={
                  <PageTitle title="Reported Issue Details">
                    <ReportedIssueDetails />
                  </PageTitle>
                }
              />
              <Route
                path={`${ROUTES.FAVOURITE}${ROUTES.RECALL_DETAILS}`}
                element={
                  <PageTitle title="Recall Details">
                    <RecallDetails />
                  </PageTitle>
                }
              />
              <Route
                path={ROUTES.SEARCH}
                element={
                  <PageTitle title="Global Search">
                    <GlobalSearch />
                  </PageTitle>
                }
              />
            </Route>
          </Route>
        </Route>
        {/* Un-auth routes */}
        <Route
          path={ROUTES.LOGIN}
          element={
            <PageTitle title="Login">
              <Login />
            </PageTitle>
          }
        />
        <Route
          path={ROUTES.REGISTER}
          element={
            <PageTitle title="Register">
              <Register />
            </PageTitle>
          }
        />
        <Route
          path={ROUTES.FORGOT_PASSWORD}
          element={
            <PageTitle title="Forgot Password">
              <ForgotPassword />
            </PageTitle>
          }
        />
        <Route
          path={ROUTES.CONFIRM_ACCOUNT}
          element={
            <PageTitle title="Confirm Account">
              <ConfirmAccount />
            </PageTitle>
          }
        />
        <Route
          path={ROUTES.RESET_PASSWORD}
          element={
            <PageTitle title="Reset Password">
              <ResetPassword />
            </PageTitle>
          }
        />
        <Route
          path="*"
          element={
            <PageTitle title="Login">
              <Login />
            </PageTitle>
          }
        />
        <Route
          path="/verify-otp"
          element={
            <PageTitle title="OTP Verification">
              <OTPVerification />
            </PageTitle>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
